export default "assets/assets/0035c307a36c17babb8d25cd02fb6488.png";